import React, { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { closeFindProductsSubscriptionsAndResetState } from "../../store/find-products/FindProductsActions";
import AppState from "../../store/AppState";
import FormControl from "@material-ui/core/FormControl";
import { selectAllCatalogs } from "../../store/catalog/CatalogSelectors";
import { LoadTopCategoriesByCatalogIdForFindProducts } from "../../store/category/CategoryActions";
import DropdownMenu from "../common/DropdownMenu";
import { resetFindProducts } from "../../store/find-products/FindProductsActions";

interface Props {
  storeId: string;
  catalog: string;
  localeId: string;
  setCatalog: React.Dispatch<React.SetStateAction<string>>;
  setCurrentModalSelectedCategory: React.Dispatch<React.SetStateAction<string>>;
}

const FindProductsCatalogSelection: React.FC<Props> = (props) => {
  const {
    storeId,
    catalog,
    localeId,
    setCatalog,
    setCurrentModalSelectedCategory,
  } = props;

  const catalogList: { name: string; id: string; code: string }[] = useSelector(
    (state: AppState) => selectAllCatalogs(state),
  );

  const dispatch = useDispatch();

  const singleCatalogId = useMemo(
    () => (catalogList.length === 1 ? catalogList[0].id : undefined),
    [catalogList],
  );

  useEffect(() => {
    if (!singleCatalogId || catalog === singleCatalogId) {
      return;
    }
    dispatch(closeFindProductsSubscriptionsAndResetState(catalog));
    setCatalog(singleCatalogId);
    setCurrentModalSelectedCategory("");
    dispatch(
      LoadTopCategoriesByCatalogIdForFindProducts(
        singleCatalogId,
        localeId,
        storeId,
      ),
    );
  }, [
    singleCatalogId,
    catalog,
    dispatch,
    localeId,
    storeId,
    setCatalog,
    setCurrentModalSelectedCategory,
  ]);

  const handleCatalogChange = (event: any) => {
    const changeEvent = event as React.ChangeEvent<{ value: string }>;
    dispatch(closeFindProductsSubscriptionsAndResetState(catalog));
    setCatalog(changeEvent.target.value);
    if (changeEvent.target.value !== "") {
      dispatch(resetFindProducts());
      setCurrentModalSelectedCategory("");
      dispatch(
        LoadTopCategoriesByCatalogIdForFindProducts(
          changeEvent.target.value,
          localeId,
          storeId,
        ),
      );
    }
  };

  return (
    <FormControl>
      <DropdownMenu
        menuId="FindProductsCatalogSelection"
        value={catalog}
        changeHandler={handleCatalogChange}
        catalogList={catalogList}
      />
    </FormControl>
  );
};

export default React.memo(FindProductsCatalogSelection);
